<template>
    <div>
        <v-overlay v-if="company.logoUrl == null && !companyNotAvailable">
            <v-progress-circular
                indeterminate
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <p v-if="companyNotAvailable">Sorry service not available</p>
        <v-container>
            <v-col
                cols="12"
                :class="{'d-none': company.logoUrl === null, 'd-flex': company.logoUrl}"
                class="d-none justify-center"
                style="margin-top: 10%;">
                <div class="form-login" v-if="loginMenu" :width="385">
                    <img class="d-table ma-auto" :src="company.logoUrl" style="width: 300px"/>

                    <v-form v-model="loginFormValid" ref="loginForm">
                        <v-col cols="12">
                            <v-text-field label="Username" single-line v-model="email" :rules="emailRules">
                                <v-icon slot="prepend">mdi-account</v-icon>
                            </v-text-field>
                            <v-text-field label="Password" :type="'password'" single-line v-model="password" :rules="passwordRules">
                                <v-icon slot="prepend">mdi-lock</v-icon>
                            </v-text-field>
                        </v-col>
                        <v-card-actions>
                            <v-container style="margin-top: -10px">
                                <v-progress-circular
                                    v-if="loading"
                                    class="d-flex mx-auto"
                                    indeterminate
                                    size="30"
                                    color="primary"/>
                                <span v-if="loginError && !loading" style="color: red">The email or password you provided is incorrect</span>
                                <v-btn v-if="!loading" color="primary" dark @click="login" block>Log In</v-btn>
                                <a @click="loginMenu = false" class="caption mt-3 d-block">Forgot password?</a>
                            </v-container>
                        </v-card-actions>
                    </v-form>
                </div>

                <v-card class="form-forgot" v-if="!loginMenu && !forgotSent" :width="385">
                    <v-form v-model="passwordFormValid" ref="passwordForm">
                        <v-col cols="12">
                            <p class="forgot-title">
                                Forgot your login?
                            </p>
                            <v-text-field label="Enter your email" single-line v-model="email" :rules="emailRules">
                            </v-text-field>
                        </v-col>
                        <v-card-actions>
                            <template>
                                <v-btn color="primary" icon small @click="loginMenu = true">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn depressed class="btn-primary-action" @click="passwordReset">Next</v-btn>
                            </template>

                        </v-card-actions>
                    </v-form>
                </v-card>

                <v-card class="form-forgot" v-if="forgotSent" :width="385">
                    <v-col cols="12">
                        <p class="forgot-title">
                            An email was sent to you. Please, follow the instructions.
                        </p>
                    </v-col>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed class="btn-primary-action" @click="forgotSent = false; loginMenu = true">Log in</v-btn>
                    </v-card-actions>
                </v-card>
                <v-dialog
                    width="640"
                    scrollable
                    persistent
                    no-click-animation
                    v-model="showTwoStepVerification">
                    <two-step-verification-modal
                        :status="twoStepVerificationStatus"
                        :phone-prop="twoStepVerificationPhone"
                        @requested="requestVerificationCode"
                        @submitted="requestVerification"></two-step-verification-modal>
                </v-dialog>
                <cookie-banner v-if="company.logoUrl"/>
            </v-col>
            <v-col v-if="company.logoUrl" col="12" style="padding-left: 10%; padding-right: 10%">
                <h3>Disclosure</h3>
                <p v-html="company.disclosureHtml"></p>
            </v-col>
        </v-container>
    </div>

</template>

<script>
import {mapGetters, mapActions, mapMutations} from "vuex";
import TwoStepVerificationModal from "@/components/modal/TwoStepVerificationModal";
import axios from "axios";
import CookieBanner from "../components/CookieBanner";
export default {
    props: {
        companyKey: {
            type: String,
            required: true
        }
    },

    components: {
        TwoStepVerificationModal,
        CookieBanner
    },

    data() {
        return {
            company: {
                logoUrl: null,
                disclosureHtml: null
            },
            companyNotAvailable: false,
            loading: false,
            loginError: false,
            companyLogoUrl: null,
            loginFormValid: false,
            passwordFormValid: false,
            loginMenu: true,
            forgotSent: false,
            showTwoStepVerification: false,
            twoStepVerificationStatus: 'unverified',
            twoStepVerificationError: {phone: null},
            twoStepVerificationPhone: '',
            email: '',
            password: '',
            passwordRules: [
                v => !!v || 'Password is required',
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
        }
    },
    computed: {
        ...mapGetters('auth', [
            'user',
            'defaultPageName'
        ]),
        ...mapGetters('draggableNavigation', [
            'homePage',
        ]),
    },

    async mounted() {
        // Clean User Data
        if (this.$route.query.cud === '1' && this.$store.state.auth.user) {
            if (this.$store.state.auth.adminMode) {
               await this.$store.dispatch('auth/logoutAdmin');
            }
            this.$store.commit('auth/clearUserData')
        } else if (this.$store.state.auth.user) {
            return this.$router.push({ name: this.homePage.name });
        }

        this.loading = true;
        axios.get(`pub/company/portal/loginData/${this.companyKey}`).then(({data}) => {
            if (data.company == null) {
                this.companyNotAvailable = true;
                return;
            }

            this.company.logoUrl = data.company.logo_url;
            this.company.disclosureHtml = data.company.disclosure;
        }).finally(() => {
            this.loading = false;
        });
    },

    methods: {
        ...mapActions('auth', [
            'requestLoginVerification',
            'verifyLogin'
        ]),
        ...mapMutations('formError', [
            'FORM_ERRORS_SET',
            'FORM_ERRORS_CLEAR'
        ]),
        ...mapMutations('settings', [
            'setCompanyKey',
        ]),
        requestVerificationCode(phone) {
            this.twoStepVerificationStatus = 'processing';
            this['FORM_ERRORS_CLEAR']('verification_phone');
            this.twoStepVerificationPhone = phone;
            this.requestLoginVerification(phone).then(
                (r) => {
                    if (!r.data.success) {
                        this.$noty.error('Sorry, we could not send the sms code. Please contact your administrator');
                        this.twoStepVerificationStatus = 'unverified';
                        return;
                    }
                    this.twoStepVerificationStatus = 'requested';
                },
                () => {
                    this.twoStepVerificationStatus = 'unverified';
                    this['FORM_ERRORS_SET']({key: 'verification_phone', errors: 'Invalid phone number'});
                }
            );
        },
        requestVerification(code) {
            this.twoStepVerificationStatus = 'processing';
            this.verifyLogin({
                code,
                email: this.email,
                password: this.password
            }).then(
                () => {
                    this.postLogin();
                },
                (response) => {
                    if (response.data.status === 'v_failed') {
                        this.twoStepVerificationStatus = 'failed';
                    } else {
                        this.twoStepVerificationStatus = 'expired';
                    }
                }
            );
        },
        login() {
            this.$refs.loginForm.validate();

            if (! this.loginFormValid) {
                return;
            }

            this.loading = true;
            this.$store
                .dispatch('auth/login', {
                    email: this.email,
                    password: this.password
                })
                .then(
                    (response) => {
                        if (response.data.status === 'pending_verification') {
                            this.showTwoStepVerification = true;
                            this.twoStepVerificationPhone = response.data?.data?.phone;
                            return;
                        }
                        this.postLogin();
                    }
                ).catch(() => {
                    this.loginError = true;
                    this.loading = false;
            });
        },
        postLogin() {
            this.$store.dispatch('individuals/loadIndividuals');
            this.$store.dispatch('individuals/loadIndividualsDropdown');
            this.$store.dispatch('company/loadCompany');
            this.$store.dispatch('beneficiaries/loadBeneficiaries');
            this.$store.dispatch('constants/loadConstants');
            this.$store.dispatch('advisor/loadAdvisor');
            this.$store.dispatch('settings/loadTooltips');
            this.$store.dispatch('household/fetchIntegrationStatus');
            this.$store.dispatch('household/fetchHousehold', this.user.household_id).then(() => {
                this.setCompanyKey(this.companyKey);
                return this.$router.push({ name: this.defaultPageName });
            }).finally(() => this.loading = false);
        },
        passwordReset() {
            this.$refs.passwordForm.validate();

            if (! this.passwordFormValid) {
                return;
            }

            this.$store
                .dispatch('auth/resetPassword', {
                    email: this.email,
                })
                .then(() => {
                    this.forgotSent = true;
                });
        },
    }
}
</script>

<style scoped>
#loading-container {
    width: 30px;
}
</style>
